// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2WZLB","row":"ProcedureTreatmentSummary_row__1l-xn"};